import layout from '@/layout'

export default {
  path: '/medicine',
  component: layout,
  redirect: '/medicine/index',
  name: 'medicineIndexs',
  meta: {
    title: '药品',
    icon: 'medicine'
  },
  children: [
    {
      path: '/medicine/index',
      name: 'medicineIndex',
      component: () => import('@/views/medicine/index'),
      meta: {
        title: '药品管理',
        icon: 'medicine'
      }
    }
  ]
}
